/*!
 * AGL DLS Components built with Stencil
 */
import { Component, Host, h, Prop } from '@stencil/core';
/**
 * Theme class for AGL
 */
export class ThemeAgl {
  render() {
    return (h(Host, null,
      h("slot", null)));
  }
  static get is() { return "dls-theme-agl"; }
  static get originalStyleUrls() { return {
    "$": ["theme-agl.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["theme-agl.css"]
  }; }
  static get properties() { return {
    "mode": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "'light' | 'dark'",
        "resolved": "\"dark\" | \"light\"",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": "This theme supports `light` or `dark` as the mode.\r\nBy default this property is not set to allow the behaviour of the theme to be set via media query, so that it will inherit from the user OS settings.\r\nUSING THIS PROPERTY WILL ONLY AFFECT CHILDREN ELEMENTS OF THIS THEME TAG.\r\nTo override the colour mode for the whole page please use the utility classes `colour-mode--light` and `colour-mode--dark`."
      },
      "attribute": "mode",
      "reflect": true
    }
  }; }
}
